import React from 'react';

import { Typography } from '@ocx/ui';

import { BoxItemComponent } from '../prices-grid/box-item.component';

interface IPriceItemProps {
  title: string;
  price: string;
}

export const PriceItemComponent: React.FC<IPriceItemProps> = ({ title, price }) => {
  return (
    <BoxItemComponent>
      <Typography variant="overline" gutterBottom color="textSecondary">
        {title}
      </Typography>
      <Typography variant="subtitle1">{price}</Typography>
    </BoxItemComponent>
  );
};
